(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.customer"] && !Shopify.designMode) return;
  try {
    class FormCustomer extends HTMLElement {
    static emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

    connectedCallback() {
      this.controller?.abort()
      const { signal } = (this.controller = new AbortController())

      const form = this.querySelector('form')
      const input = form?.querySelector('input[name="contact[email]"]')
      if (!input) return

      const validate = () => {
        const ok = FormCustomer.emailPattern.test(input.value.trim())
        input.setCustomValidity(ok ? '' : this.dataset.invalidMessage)
      }

      input.addEventListener('input', validate, { signal })
      form.addEventListener('submit', (e) => {
        validate()
        if (!form.reportValidity()) e.preventDefault()
      }, { signal, passive: false })
    }

    disconnectedCallback() {
      this.controller?.abort()
    }
  }

  customElements.define('form-customer', FormCustomer)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["laminate-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dh-flooring')) {
  customElements.define('dh-flooring', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-floor-config]').textContent);
      this.coverage = Number(this.dataset.coverage);
      this.approved = this.dataset.approved === 'true';
      this.form = this.querySelector('[data-floor-form]');
      this.one = key => this.querySelector(`[data-${key}]`);
      this.all = selector => [...this.querySelectorAll(selector)];
      this.money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-IE', {style:'currency', currency:this.dataset.currency || 'EUR'}).format(cents / 100);
      this.area = n => `${n.toFixed(2)} m²`;
      this.unit = this.querySelector('[data-unit]:checked')?.value || 'metric';
      this.entryState = this.dataset.entryState || '';
      this.skirting = null;
      this.skirtingManual = false;
      this.floorKind = this.dataset.floorKind || 'straight';

      this.addEventListener('click', event => {
        const entry = event.target.closest('[data-floor-entry]');
        if (entry) {
          this.entryState = entry.dataset.floorEntry;
          this.dataset.entryState = this.entryState;
          this.one('fitting-panel').hidden = this.entryState !== 'fit';
          this.update(false);
          setTimeout(() => this.form.scrollIntoView({behavior:'smooth',block:'start'}), 50);
          return;
        }

        if (event.target.closest('[data-open-skirting]')) {
          event.preventDefault();
          const modal = this.one('skirting-modal');
          if (modal) {
            modal.hidden = false;
            document.documentElement.style.overflow = 'hidden';
          }
          return;
        }
        if (event.target.closest('[data-close-skirting]')) {
          event.preventDefault();
          this.closeSkirtingPicker();
          return;
        }
        const profileButton = event.target.closest('[data-select-skirting-profile]');
        if (profileButton) {
          event.preventDefault();
          const profile = profileButton.closest('.dh-flooring__skirting-profile');
          const source = profile?.querySelector('[data-skirting-profile-variants]');
          const target = this.one('skirting-size');
          if (!source || !target || !source.options.length) return;

          target.innerHTML = '';
          [...source.options].forEach(sourceOption => {
            const option = document.createElement('option');
            option.value = sourceOption.value;
            option.textContent = sourceOption.textContent;
            option.dataset.price = sourceOption.dataset.price || '0';
            option.dataset.title = sourceOption.dataset.title || 'Skirting';
            option.dataset.variant = sourceOption.dataset.variant || '';
            option.dataset.image = sourceOption.dataset.image || '';
            target.appendChild(option);
          });

          this.applySkirtingVariant();
          this.skirtingManual = false;
          this.renderSkirtingSelection();
          this.closeSkirtingPicker();
          this.update(true);
          return;
        }
        if (event.target.closest('[data-remove-skirting]')) {
          event.preventDefault();
          this.skirting = null;
          this.skirtingManual = false;
          const sizeSelect = this.one('skirting-size');
          if (sizeSelect) sizeSelect.innerHTML = '';
          this.renderSkirtingSelection();
          this.update(false);
          return;
        }
        if (event.target.closest('[data-switch-floor-only]')) {
          event.preventDefault();
          this.entryState = 'floor';
          this.dataset.entryState = 'floor';
          this.one('fitting-panel').hidden = true;
          this.update(false);
          return;
        }
        if (event.target.closest('[data-book-floor-survey]')) {
          this.bookSurvey(event);
          return;
        }
      });

      this.one('skirting-modal')?.addEventListener('click', event => {
        if (event.target === this.one('skirting-modal')) this.closeSkirtingPicker();
      });

      this.form.addEventListener('change', event => {
        if (event.target.matches('[data-skirting-size]')) {
          this.applySkirtingVariant();
          this.renderSkirtingSelection();
          this.update(false);
        }
      });

      this.form.addEventListener('input', event => {
        if (event.target.matches('[data-packs]')) this.update(false);
        else if (event.target.matches('[data-skirting-lengths]')) {
          this.skirtingManual = true;
          this.update(false);
        }
        else if (event.target.matches('[data-length-m],[data-width-m],[data-length-ft],[data-length-in],[data-width-ft],[data-width-in]')) {
          this.skirtingManual = false;
          this.update(true);
        }
      });

      this.form.addEventListener('change', event => {
        if (event.target.matches('[data-remove-old-floor],[data-remove-old-skirting]')) {
          this.update(false);
          return;
        }
        if (event.target.matches('[data-variant-picker]')) this.one('variant').value = event.target.value;
        if (event.target.matches('[data-unit]')) {
          const next = event.target.value;
          if (next !== this.unit) this.convertRooms(this.unit, next);
          this.unit = next;
          this.syncUnitVisibility();
          this.update(true);
          return;
        }
        this.update(event.target.matches('[data-waste]'));
      });

      this.form.addEventListener('click', event => {
        const addRoom = event.target.closest('[data-add-room]');
        if (addRoom) {
          event.preventDefault();
          this.addRoom();
          return;
        }
        const removeRoom = event.target.closest('[data-remove-room]');
        if (removeRoom) {
          event.preventDefault();
          const room = removeRoom.closest('[data-room]');
          if (room && this.all('[data-room]').length > 1) {
            room.remove();
            this.renumberRooms();
            this.update(true);
          }
          return;
        }
        if (event.target.closest('[data-submit]')) this.add(event);
      }, true);

      this.syncUnitVisibility();
      this.renumberRooms();
      this.update(false);
    }

    closeSkirtingPicker() {
      const modal = this.one('skirting-modal');
      if (modal) modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    applySkirtingVariant() {
      const select = this.one('skirting-size');
      const option = select?.options[select.selectedIndex];
      if (!option) return;

      const mmMatch = option.dataset.variant?.match(/(\d{4})\s*mm/i);
      const lengthM = mmMatch ? Number(mmMatch[1]) / 1000 : 4.2;

      this.skirting = {
        id:Number(option.value),
        price:Number(option.dataset.price || 0),
        title:option.dataset.title || 'Skirting',
        variant:option.dataset.variant || '',
        image:option.dataset.image || '',
        lengthM
      };
    }

    renderSkirtingSelection() {
      const selected = this.one('skirting-selected');
      const qtyWrap = this.one('skirting-qty-wrap');
      const sizeWrap = this.one('skirting-size-wrap');
      if (!this.skirting) {
        selected.hidden = true;
        qtyWrap.hidden = true;
        sizeWrap.hidden = true;
        this.one('skirting-line').hidden = true;
        return;
      }
      selected.hidden = false;
      qtyWrap.hidden = false;
      sizeWrap.hidden = false;
      this.one('skirting-selected-title').textContent = this.skirting.title.replace(/^SEADEC Optima\s*/i,'').replace(/\s*Deluxe Primed Skirting.*$/i,'');
      this.one('skirting-selected-variant').textContent = this.skirting.variant;
      this.one('skirting-selected-price').textContent = this.money(this.skirting.price) + ' per length';
      const img = this.one('skirting-selected-image');
      img.src = this.skirting.image || '';
      img.hidden = !this.skirting.image;
    }

    fittingRate(area) {
      if (this.floorKind === 'herringbone') {
        return {rate:39, minimum:550};
      }
      if (this.floorKind === 'straight') {
        return {rate:25, minimum:350};
      }
      if (this.floorKind === 'spc-herringbone') {
        if (area >= 80) return {rate:35, minimum:500};
        if (area >= 50) return {rate:37, minimum:500};
        return {rate:40, minimum:500};
      }
      if (area >= 80) return {rate:17, minimum:350};
      if (area >= 50) return {rate:18, minimum:350};
      return {rate:20, minimum:350};
    }

    addRoom() {
      const rooms = this.all('[data-room]');
      if (rooms.length >= 10) return;
      const fragment = this.one('room-template').content.cloneNode(true);
      this.one('rooms').appendChild(fragment);
      this.renumberRooms();
      this.syncUnitVisibility();
      this.update(true);
      const newest = this.all('[data-room]').at(-1);
      newest?.querySelector(this.unit === 'metric' ? '[data-length-m]' : '[data-length-ft]')?.focus();
    }

    renumberRooms() {
      const rooms = this.all('[data-room]');
      rooms.forEach((room, index) => {
        const number = room.querySelector('[data-room-number]');
        if (number) number.textContent = index + 1;
        const remove = room.querySelector('[data-remove-room]');
        if (remove) remove.hidden = rooms.length === 1;
      });
      this.one('add-room').hidden = rooms.length >= 10;
    }

    syncUnitVisibility() {
      this.all('[data-room]').forEach(room => {
        room.querySelector('[data-metric-fields]').hidden = this.unit !== 'metric';
        room.querySelector('[data-imperial-fields]').hidden = this.unit !== 'imperial';
      });
    }

    convertRooms(from, to) {
      this.all('[data-room]').forEach(room => {
        if (from === 'metric' && to === 'imperial') {
          this.metresToImperial(room.querySelector('[data-length-m]'), room.querySelector('[data-length-ft]'), room.querySelector('[data-length-in]'));
          this.metresToImperial(room.querySelector('[data-width-m]'), room.querySelector('[data-width-ft]'), room.querySelector('[data-width-in]'));
        } else if (from === 'imperial' && to === 'metric') {
          this.imperialToMetres(room.querySelector('[data-length-ft]'), room.querySelector('[data-length-in]'), room.querySelector('[data-length-m]'));
          this.imperialToMetres(room.querySelector('[data-width-ft]'), room.querySelector('[data-width-in]'), room.querySelector('[data-width-m]'));
        }
      });
    }

    metresToImperial(metreInput, feetInput, inchInput) {
      if (!metreInput || metreInput.value === '') {
        feetInput.value = '';
        inchInput.value = '';
        return;
      }
      const metres = metreInput.valueAsNumber;
      if (!Number.isFinite(metres) || metres <= 0) return;
      let totalInches = metres / 0.0254;
      let feet = Math.floor(totalInches / 12);
      let inches = Math.round((totalInches - feet * 12) * 100) / 100;
      if (inches >= 12) { feet += 1; inches = 0; }
      feetInput.value = feet;
      inchInput.value = inches;
    }

    imperialToMetres(feetInput, inchInput, metreInput) {
      const ftBlank = feetInput.value === '';
      const inBlank = inchInput.value === '';
      if (ftBlank && inBlank) {
        metreInput.value = '';
        return;
      }
      const feet = ftBlank ? 0 : feetInput.valueAsNumber;
      const inches = inBlank ? 0 : inchInput.valueAsNumber;
      if (!Number.isFinite(feet) || !Number.isFinite(inches) || feet < 0 || inches < 0) return;
      metreInput.value = Math.round(((feet * 12 + inches) * 0.0254) * 10000) / 10000;
    }

    readImperial(feetInput, inchInput) {
      const ftBlank = feetInput.value === '';
      const inBlank = inchInput.value === '';
      const blank = ftBlank && inBlank;
      if (blank) return {blank:true, valid:false, metres:null};
      const feet = ftBlank ? 0 : feetInput.valueAsNumber;
      const inches = inBlank ? 0 : inchInput.valueAsNumber;
      const valid = Number.isFinite(feet) && Number.isFinite(inches) && feet >= 0 && inches >= 0 && inches < 12 && (feet > 0 || inches > 0);
      return {blank:false, valid, metres:valid ? (feet * 12 + inches) * 0.0254 : null};
    }

    selectedUnderlay() {
      const choice = this.querySelector('[data-underlay]:checked');
      if (!choice || choice.value === 'none') return {choice, key:'none', item:null};
      const id = Number(choice.dataset.underlayId || 0);
      const price = Number(choice.dataset.underlayPrice || 0);
      const coverage = Number(choice.dataset.underlayCoverage || 0);
      const available = choice.dataset.underlayAvailable === 'true';
      return {
        choice,
        key: choice.value,
        item: {id, price, coverage, available}
      };
    }

    readRoom(room) {
      let blank;
      let valid;
      let length;
      let width;

      if (this.unit === 'metric') {
        const lengthInput = room.querySelector('[data-length-m]');
        const widthInput = room.querySelector('[data-width-m]');
        const lengthBlank = lengthInput.value === '';
        const widthBlank = widthInput.value === '';
        blank = lengthBlank && widthBlank;
        length = lengthInput.valueAsNumber;
        width = widthInput.valueAsNumber;
        valid = !blank && !lengthBlank && !widthBlank && Number.isFinite(length) && Number.isFinite(width) && length > 0 && width > 0 && length <= 10000 && width <= 10000;
      } else {
        const l = this.readImperial(room.querySelector('[data-length-ft]'), room.querySelector('[data-length-in]'));
        const w = this.readImperial(room.querySelector('[data-width-ft]'), room.querySelector('[data-width-in]'));
        blank = l.blank && w.blank;
        valid = !blank && l.valid && w.valid;
        length = l.metres;
        width = w.metres;
      }

      const area = valid ? length * width : null;
      const output = room.querySelector('[data-room-area]');
      if (output) output.textContent = area === null ? '—' : this.area(area);
      const perimeter = valid ? 2 * (length + width) : null;
      return {blank, valid, area, perimeter};
    }

    update(recalculate) {
      const roomResults = this.all('[data-room]').map(room => this.readRoom(room));
      const enteredRooms = roomResults.filter(result => !result.blank);
      const blank = enteredRooms.length === 0;
      const validRoom = !blank && enteredRooms.every(result => result.valid);
      const room = validRoom ? enteredRooms.reduce((sum, result) => sum + result.area, 0) : null;
      const perimeter = validRoom ? enteredRooms.reduce((sum, result) => sum + (result.perimeter || 0), 0) : null;

      const waste = Number(this.querySelector('[data-waste]:checked').value);
      const validWaste = [0,5,10,15].includes(waste);
      const required = room === null || !validWaste ? null : room * (1 + waste / 100);
      const validCoverage = Number.isFinite(this.coverage) && this.coverage > 0;
      const roundUp = value => Math.ceil(value - Number.EPSILON * Math.max(1,Math.abs(value)) * 4);
      const recommended = required !== null && validCoverage ? roundUp(required / this.coverage) : null;

      if (recalculate && recommended !== null) this.one('packs').value = recommended;

      const packs = this.one('packs').valueAsNumber;
      const validPacks = Number.isSafeInteger(packs) && packs >= 1 && packs <= 99999;
      this.variant = this.config.variants.find(v => String(v.id) === this.one('variant').value);
      const selectedUnderlay = this.selectedUnderlay();
      const underlayChoice = selectedUnderlay.choice;
      const underlayKey = selectedUnderlay.key;
      const u = selectedUnderlay.item;
      const validUnderlay = !u || (Number.isSafeInteger(u.id) && u.id > 0 && u.available && Number.isFinite(u.coverage) && u.coverage > 0 && required !== null);
      const rolls = u && validUnderlay ? roundUp(required / u.coverage) : 0;

      this.one('area-result').hidden = recommended === null;
      this.one('enter').hidden = room !== null;
      this.one('area').textContent = room === null ? '—' : this.area(room);
      this.one('required').textContent = required === null ? '—' : this.area(required);
      this.one('waste-label').textContent = waste;
      this.one('recommended').textContent = recommended === null ? '—' : recommended;
      this.one('supplied').textContent = validPacks && validCoverage ? this.area(packs * this.coverage) : '—';
      this.one('short').hidden = !(validPacks && recommended !== null && packs < recommended);

      this.one('underlay-results').hidden = !u;
      this.one('roll-coverage').textContent = u ? this.area(u.coverage) : '—';
      this.one('rolls').textContent = u && validUnderlay ? rolls : '—';
      this.one('underlay-supplied').textContent = u && validUnderlay ? this.area(rolls * u.coverage) : '—';

      let skirtingQty = 0;
      let skirtingRecommended = null;
      let skirtingTotal = 0;
      if (this.skirting) {
        if (perimeter !== null && Number.isFinite(this.skirting.lengthM) && this.skirting.lengthM > 0) {
          skirtingRecommended = roundUp((perimeter * 1.10) / this.skirting.lengthM);
          if (recalculate && !this.skirtingManual) this.one('skirting-lengths').value = skirtingRecommended;
        }
        skirtingQty = this.one('skirting-lengths').valueAsNumber;
        if (!Number.isSafeInteger(skirtingQty) || skirtingQty < 1) skirtingQty = skirtingRecommended || 1;
        skirtingTotal = skirtingQty * this.skirting.price;
      }

      this.one('skirting-recommended').textContent = skirtingRecommended === null ? '—' : skirtingRecommended;
      this.one('skirting-perimeter').textContent = perimeter === null ? '—' : this.area(perimeter);
      this.one('skirting-line').hidden = !this.skirting;
      this.one('skirting-total').textContent = this.skirting ? this.money(skirtingTotal) : this.money(0);
      this.one('skirting-description').textContent = this.skirting ? `${skirtingQty} × ${this.skirting.variant} · ${this.money(this.skirting.price)}` : '';

      const priced = this.approved && this.variant && this.variant.price > 0;
      const floorTotal = validPacks && priced ? packs * this.variant.price : null;
      const underlayTotal = validUnderlay ? rolls * (u ? u.price : 0) : null;
      const total = floorTotal === null || underlayTotal === null ? null : floorTotal + underlayTotal + skirtingTotal;

      if (this.one('pack-price')) this.one('pack-price').textContent = priced ? this.money(this.variant.price) : this.config.strings.pending;
      if (this.one('metre-price')) this.one('metre-price').textContent = priced && validCoverage ? this.money(this.variant.price / this.coverage) : '—';
      this.one('floor-total').textContent = floorTotal === null ? this.config.strings.pending : this.money(floorTotal);
      this.one('underlay-total').textContent = underlayTotal === null ? '—' : u ? this.money(underlayTotal) : this.money(0);
      this.one('floor-line').textContent = priced && validPacks ? `${packs} × ${this.money(this.variant.price)}` : '';
      this.one('underlay-line').hidden = !u;
      this.one('underlay-description').textContent = u && underlayChoice ? `${rolls} × ${underlayChoice.nextElementSibling.firstChild.textContent.trim()} · ${this.money(u.price)}` : '';
      this.one('total').textContent = total === null ? '—' : this.money(total);

      let fittingTotal = 0;
      let floorFitting = 0;
      let skirtingFitting = 0;
      let oldFloorRemoval = 0;
      let oldSkirtingRemoval = 0;

      const removeOldFloorInput = this.one('remove-old-floor');
      const removeOldSkirtingInput = this.one('remove-old-skirting');
      const oldSkirtingOption = this.one('old-skirting-option');

      if (room !== null) {
        oldFloorRemoval = Math.round(room * 8.5 * 100);
      }

      if (this.skirting && skirtingQty > 0) {
        oldSkirtingOption?.classList.remove('is-disabled');
        if (removeOldSkirtingInput) removeOldSkirtingInput.disabled = false;
        const selectedSkirtingMetres = skirtingQty * (this.skirting.lengthM || 4.2);
        oldSkirtingRemoval = Math.round(selectedSkirtingMetres * 3 * 100);
        this.one('old-skirting-help').textContent = skirtingQty + ' selected lengths used to calculate this removal total.';
      } else {
        oldSkirtingOption?.classList.add('is-disabled');
        if (removeOldSkirtingInput) {
          removeOldSkirtingInput.checked = false;
          removeOldSkirtingInput.disabled = true;
        }
        this.one('old-skirting-help').textContent = 'Select your new skirting above and we’ll calculate the removal total automatically.';
      }

      this.one('old-floor-removal-total').textContent = room === null ? '—' : this.money(oldFloorRemoval);
      this.one('old-skirting-removal-total').textContent =
        (this.skirting && skirtingQty > 0) ? this.money(oldSkirtingRemoval) : '—';

      if (this.entryState === 'fit' && room !== null) {
        const rateInfo = this.fittingRate(room);
        floorFitting = Math.max(rateInfo.minimum * 100, Math.round(room * rateInfo.rate * 100));
        if (this.skirting && perimeter !== null) skirtingFitting = Math.round(perimeter * 6 * 100);

        const selectedFloorRemoval = removeOldFloorInput?.checked ? oldFloorRemoval : 0;
        const selectedSkirtingRemoval = removeOldSkirtingInput?.checked ? oldSkirtingRemoval : 0;
        fittingTotal = floorFitting + skirtingFitting + selectedFloorRemoval + selectedSkirtingRemoval;

        this.one('fitting-panel').hidden = false;
        this.one('fitting-area').textContent = this.area(room);
        this.one('floor-fitting-total').textContent = this.money(floorFitting);
        this.one('fitting-total').textContent = this.money(fittingTotal);
        this.one('project-total').textContent = total === null ? '—' : this.money(total + fittingTotal);
        this.one('fitting-rate-copy').textContent =
          (this.floorKind.includes('herringbone') ? 'Herringbone fitting' : 'Straight-lay fitting') +
          ' · ' + this.money(rateInfo.rate * 100) + '/m² · minimum ' + this.money(rateInfo.minimum * 100) + '.';

        this.one('skirting-fitting-line').hidden = !this.skirting;
        this.one('skirting-fitting-total').textContent = this.skirting ? this.money(skirtingFitting) : this.money(0);

        this.one('old-floor-removal-line').hidden = !removeOldFloorInput?.checked;
        this.one('old-floor-removal-summary').textContent = this.money(oldFloorRemoval);
        this.one('old-skirting-removal-line').hidden = !removeOldSkirtingInput?.checked;
        this.one('old-skirting-removal-summary').textContent = this.money(oldSkirtingRemoval);
      } else {
        this.one('fitting-panel').hidden = true;
      }

      this.one('submit').textContent = this.entryState === 'fit' ? 'Add materials to cart' : this.config.strings.add;

      let error = '';
      if (!validCoverage) error = this.config.strings.missing;
      else if ((!validRoom && !blank) || !validWaste || !validPacks || recommended > 99999) error = this.config.strings.invalid;
      else if (u && required === null) error = this.config.strings.manual_underlay;
      else if (!validUnderlay || !this.variant || !this.variant.available) error = this.config.strings.unavailable;

      this.one('error').textContent = error;
      this.one('error').hidden = !error;
      this.state = {
        packs,
        rolls,
        underlayKey,
        underlayId: u && validUnderlay ? u.id : null,
        skirtingId: this.skirting ? this.skirting.id : null,
        skirtingQty,
        materialTotal: total,
        roomArea: room,
        perimeter,
        fittingTotal,
        floorFitting,
        skirtingFitting,
        oldFloorRemoval: this.one('remove-old-floor')?.checked ? oldFloorRemoval : 0,
        oldSkirtingRemoval: this.one('remove-old-skirting')?.checked ? oldSkirtingRemoval : 0,
        valid: !error && priced && Number.isSafeInteger(total)
      };
      this.one('submit').disabled = !this.state.valid || this.busy || this.uncertain;
      return this.state;
    }

    async bookSurvey(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const select = this.one('floor-survey-area');
      if (!select || this.busy) return;
      const option = select.options[select.selectedIndex];
      const state = this.update(false);
      if (!state.valid || !state.roomArea || this.entryState !== 'fit') return;

      this.busy = true;
      const button = this.one('book-floor-survey');
      const oldText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding survey…';

      const properties = {
        'Flooring': this.dataset.productTitle || 'Flooring',
        'Floor area': this.area(state.roomArea),
        'Material estimate': this.money(state.materialTotal || 0),
        'Fitting guide': this.money(state.fittingTotal || 0),
        'Old floor removal': state.oldFloorRemoval ? this.money(state.oldFloorRemoval) : 'No',
        'Old skirting removal': state.oldSkirtingRemoval ? this.money(state.oldSkirtingRemoval) : 'No',
        'Estimated project total': this.money((state.materialTotal || 0) + (state.fittingTotal || 0)),
        'Skirting': this.skirting ? (this.skirting.title + ' — ' + this.skirting.variant + ' × ' + state.skirtingQty) : 'None',
        'Survey credit': 'Fully credited against fitting if job proceeds'
      };

      try {
        const response = await fetch(this.dataset.addUrl, {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({
            items:[{id:Number(option.value),quantity:1,properties}],
            sections:['cart-ajax'],
            sections_url:window.location.pathname
          })
        });
        const result = await response.json();
        const cartSection = result?.sections?.['cart-ajax'];
        if (!response.ok || !cartSection) throw new Error('Survey could not be added.');

        const headerCart = document.querySelector('header-cart-drawer');
        if (headerCart?.cartForm?.cartMarkup) headerCart.cartForm.cartMarkup(cartSection);

        const parsedCart = new DOMParser().parseFromString(cartSection,'text/html');
        const newBubble = parsedCart.querySelector('.cart-link__bubble');
        const currentBubble = document.querySelector('.cart-link__bubble');
        if (newBubble && currentBubble) currentBubble.outerHTML = newBubble.outerHTML;

        const cartTrigger =
          document.querySelector(`toggle-cart a[href="${window.Shopify.routes.root}cart"]`) ||
          document.querySelector(`a[href="${this.dataset.cartUrl}"]`);
        if (cartTrigger) cartTrigger.click();
        else window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.one('error').textContent = 'We could not add the flooring survey. Please try again.';
        this.one('error').hidden = false;
      } finally {
        this.busy = false;
        button.disabled = false;
        button.textContent = oldText;
      }
    }

    async add(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy || this.uncertain || !this.update(false).valid) return;
      this.busy = true;
      this.one('submit').disabled = true;
      this.one('submit').textContent = this.config.strings.adding;
      const items = [{id:Number(this.variant.id), quantity:this.state.packs}];
      const selectedUnderlay = this.selectedUnderlay();
      if (selectedUnderlay.item && this.state.rolls > 0) {
        items.push({id:selectedUnderlay.item.id, quantity:this.state.rolls});
      }
      if (this.skirting && this.state.skirtingQty > 0) {
        items.push({id:this.skirting.id, quantity:this.state.skirtingQty});
      }
      const controls = [...this.form.querySelectorAll('input,select,button')];
      controls.forEach(el => el.disabled = true);
      try {
        const response = await fetch(this.dataset.addUrl, {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({
            items,
            sections:['cart-ajax'],
            sections_url:window.location.pathname
          })
        });
        const result = await response.json();
        const cartSection = result?.sections?.['cart-ajax'];
        if (!response.ok || !Array.isArray(result.items) || result.items.length !== items.length || !cartSection) {
          throw new Error(this.config.strings.failure);
        }

        const headerCart = document.querySelector('header-cart-drawer');
        if (headerCart?.cartForm?.cartMarkup) {
          headerCart.cartForm.cartMarkup(cartSection);
        }

        const parsedCart = new DOMParser().parseFromString(cartSection, 'text/html');
        const newBubble = parsedCart.querySelector('.cart-link__bubble');
        const currentBubble = document.querySelector('.cart-link__bubble');
        if (newBubble && currentBubble) currentBubble.outerHTML = newBubble.outerHTML;

        const cartTrigger =
          document.querySelector(`toggle-cart a[href="${window.Shopify.routes.root}cart"]`) ||
          document.querySelector(`a[href="${this.dataset.cartUrl}"]`);

        if (cartTrigger) {
          cartTrigger.click();
        } else {
          window.location.assign(this.dataset.cartUrl);
        }
      } catch (error) {
        this.uncertain = true;
        this.one('error').textContent = this.config.strings.failure;
        this.one('error').hidden = false;
        this.one('cart-link').hidden = false;
      } finally {
        this.busy = false;
        controls.forEach(el => el.disabled = false);
        this.one('submit').textContent = this.config.strings.add;
        this.update(false);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', () => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener('product-form:submit:error', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.displayErrorMessage(event.detail.errorMessage)
        }
      }, { signal: this.abortController.signal })

      document.addEventListener('product-form:submit:success', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }, { signal: this.abortController.signal })
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of this.querySelectorAll('input')) {
        element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) {
            return
          }

          inputElement.setAttribute('aria-invalid', true)
        })
      }
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.media-gallery__slide');
      this.thumbs = this.querySelectorAll('.media-gallery__thumb');
      this.prevBtn = this.querySelector('.media-gallery__nav--prev');
      this.nextBtn = this.querySelector('.media-gallery__nav--next');
      this.mainContainer = this.querySelector('.media-gallery__main');
      this.currentIndex = 0;
      this.isAnimating = false;
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial';

      // Touch/swipe handling
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.minSwipeDistance = 50;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true); // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver();
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev';
          this.goToSlide(index, direction);
        });
      });

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previousSlide();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextSlide();
        });
      }

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0');

      // Add touch/swipe handlers
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return;
      if (index === this.currentIndex) return;
      if (this.isAnimating) return;

      const currentSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide);

      // Reset all slides
      this.resetSlides();

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction);

      // Update UI state
      this.updateThumbnails(index);
      this.currentIndex = index;

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction);

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight();
        }, 50); // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next');
      });
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--is-animating');
      });

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)';
          }
        });
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)';
          }
        });
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex].classList.remove('media-gallery__thumb--active');
      this.thumbs[activeIndex].classList.add('media-gallery__thumb--active');
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return;

      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition');
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img');
      if (!img) return;

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight;

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth;

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio;

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px';
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity;
        const originalTransform = activeSlide.style.transform;
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateX(0)';
        activeSlide.style.position = 'relative';
        activeSlide.style.visibility = 'hidden';

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight;

        // Restore original styles
        activeSlide.style.opacity = originalOpacity;
        activeSlide.style.transform = originalTransform;
        activeSlide.style.position = '';
        activeSlide.style.visibility = '';

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px';
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition');
        }, 10);
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight();
      });

      // Observe all images in the slides
      this.slides.forEach(slide => {
        const images = slide.querySelectorAll('img');
        images.forEach(img => {
          this.resizeObserver.observe(img);

          // Also listen for load events to recalculate when image loads
          img.addEventListener('load', () => {
            if (slide.classList.contains('media-gallery__slide--active')) {
              this.adjustContainerHeight();
            }
          });
        });
      });
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true;

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating');
        targetSlide.classList.add('media-gallery__slide--is-animating');

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)';
          } else {
            currentSlide.style.transform = 'translateX(100%)';
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)';
          targetSlide.classList.add('media-gallery__slide--active');

          // Clean up after animation
          this.waitForTransition(currentSlide).then(() => {
            this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction);
            this.scrollActiveThumbnailIntoView();
            // Hydrate and autoplay current slide media if eligible and pause others
            this.pauseNonActiveSlides();
            this.autoplayActiveSlideIfEligible();
            // Clear animation flag
            this.isAnimating = false;
          });
        });
      });
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active');
      targetSlide.classList.remove('media-gallery__slide--is-animating');

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)';
      } else {
        currentSlide.style.transform = 'translateX(-100%)';
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight();
      }
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'next');
    }

    previousSlide() {
      const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex, 'prev');
    }

    waitForTransition(element) {
      return new Promise((resolve) => {
        const handleTransitionEnd = (e) => {
          if (e.target === element) {
            element.removeEventListener('transitionend', handleTransitionEnd);
            resolve();
          }
        };
        element.addEventListener('transitionend', handleTransitionEnd);
      });
    }

    handleTouchStart(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    handleTouchMove(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (this.isAnimating) return;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide();
        } else {
          // Swipe left - go to next slide
          this.nextSlide();
        }
      }
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : []);
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause();
        }
      });
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause());
        }
      });
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media');
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return;
        if (element.hasAttribute('playing')) return;
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play();
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'loaded' && element.hasAttribute('loaded')) {
                observer.disconnect();
                element.play();
                break;
              }
            }
          });

          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] });
        }
      });
    }
  }

  // Define the custom element
  customElements.define('media-gallery', MediaGalleryElement);
  } catch(e) { console.error(e); }
})();

})();
